// 常用国家列表（前端可中文展示，提交给后端仍使用 code）
export const COUNTRIES = [
  { code: 'CHN', nameEn: "PEOPLE'S REPUBLIC OF CHINA", nameCn: '中国', displayEn: "CHN (PEOPLE'S REPUBLIC OF CHINA)" },
  { code: 'HKG', nameEn: 'HONG KONG', nameCn: '中国香港', displayEn: 'HKG (HONG KONG)' },
  { code: 'MAC', nameEn: 'MACAO', nameCn: '中国澳门', displayEn: 'MAC (MACAO)' },
  { code: 'TWN', nameEn: 'TAIWAN', nameCn: '中国台湾', displayEn: 'TWN (TAIWAN)' },

  // 其余国家/地区先保持英文展示（但保留中文名用于“过去两周访问国家”）
  { code: 'USA', nameEn: 'UNITED STATES OF AMERICA', nameCn: '美国', displayEn: 'USA (UNITED STATES OF AMERICA)' },
  { code: 'GBR', nameEn: 'UNITED KINGDOM', nameCn: '英国', displayEn: 'GBR (UNITED KINGDOM)' },
  { code: 'JPN', nameEn: 'JAPAN', nameCn: '日本', displayEn: 'JPN (JAPAN)' },
  { code: 'KOR', nameEn: 'REPUBLIC OF KOREA', nameCn: '韩国', displayEn: 'KOR (REPUBLIC OF KOREA)' },
  { code: 'SGP', nameEn: 'SINGAPORE', nameCn: '新加坡', displayEn: 'SGP (SINGAPORE)' },
  { code: 'MYS', nameEn: 'MALAYSIA', nameCn: '马来西亚', displayEn: 'MYS (MALAYSIA)' },
  { code: 'VNM', nameEn: 'VIETNAM', nameCn: '越南', displayEn: 'VNM (VIETNAM)' },
  { code: 'IDN', nameEn: 'INDONESIA', nameCn: '印度尼西亚', displayEn: 'IDN (INDONESIA)' },
  { code: 'PHL', nameEn: 'PHILIPPINES', nameCn: '菲律宾', displayEn: 'PHL (PHILIPPINES)' },
  { code: 'IND', nameEn: 'INDIA', nameCn: '印度', displayEn: 'IND (INDIA)' },
  { code: 'AUS', nameEn: 'AUSTRALIA', nameCn: '澳大利亚', displayEn: 'AUS (AUSTRALIA)' },
  { code: 'DEU', nameEn: 'GERMANY', nameCn: '德国', displayEn: 'DEU (GERMANY)' },
  { code: 'FRA', nameEn: 'FRANCE', nameCn: '法国', displayEn: 'FRA (FRANCE)' },
  { code: 'RUS', nameEn: 'RUSSIAN FEDERATION', nameCn: '俄罗斯', displayEn: 'RUS (RUSSIAN FEDERATION)' },
  { code: 'CAN', nameEn: 'CANADA', nameCn: '加拿大', displayEn: 'CAN (CANADA)' },
];

// 中国省份/直辖市（前端中文展示，提交给后端仍使用英文枚举）
export const CHINA_CITIES = [
  { value: 'BEIJING', labelCn: '北京' },
  { value: 'SHANGHAI', labelCn: '上海' },
  { value: 'TIANJIN', labelCn: '天津' },
  { value: 'CHONGQING', labelCn: '重庆' },
  { value: 'ANHUI', labelCn: '安徽' },
  { value: 'FUJIAN', labelCn: '福建' },
  { value: 'GANSU', labelCn: '甘肃' },
  { value: 'GUANGDONG', labelCn: '广东' },
  { value: 'GUANGXI', labelCn: '广西' },
  { value: 'GUIZHOU', labelCn: '贵州' },
  { value: 'HAINAN', labelCn: '海南' },
  { value: 'HEBEI', labelCn: '河北' },
  { value: 'HEILONGJIANG', labelCn: '黑龙江' },
  { value: 'HENAN', labelCn: '河南' },
  { value: 'HUBEI', labelCn: '湖北' },
  { value: 'HUNAN', labelCn: '湖南' },
  { value: 'INNER MONGOLIA', labelCn: '内蒙古' },
  { value: 'JIANGSU', labelCn: '江苏' },
  { value: 'JIANGXI', labelCn: '江西' },
  { value: 'JILIN', labelCn: '吉林' },
  { value: 'LIAONING', labelCn: '辽宁' },
  { value: 'NINGXIA', labelCn: '宁夏' },
  { value: 'QINGHAI', labelCn: '青海' },
  { value: 'SHAANXI', labelCn: '陕西' },
  { value: 'SHANDONG', labelCn: '山东' },
  { value: 'SHANXI', labelCn: '山西' },
  { value: 'SICHUAN', labelCn: '四川' },
  { value: 'TIBET', labelCn: '西藏' },
  { value: 'XINJIANG', labelCn: '新疆' },
  { value: 'YUNNAN', labelCn: '云南' },
  { value: 'ZHEJIANG', labelCn: '浙江' },
];

// 泰国省份列表（常去目的地优先；前端中文展示，提交仍为英文 value）
const THAILAND_PROVINCES_COMMON = [
  { value: 'BANGKOK', labelCn: '曼谷' },
  { value: 'PHUKET', labelCn: '普吉' },
  { value: 'CHON BURI', labelCn: '春武里（芭提雅等）' },
  { value: 'SURAT THANI', labelCn: '素叻他尼（苏梅/帕岸等）' },
  { value: 'CHIANG MAI', labelCn: '清迈' },
  { value: 'KRABI', labelCn: '甲米' },
  { value: 'PRACHUAP KHIRI KHAN', labelCn: '巴蜀（华欣等）' },
  { value: 'PHANG NGA', labelCn: '攀牙（考拉/攀牙湾等）' },
  { value: 'SONGKHLA', labelCn: '宋卡（合艾等）' },
  { value: 'CHIANG RAI', labelCn: '清莱' },
];

const THAILAND_PROVINCES_ALL = [
  'BANGKOK', 'AMNAT CHAROEN', 'ANG THONG', 'BUENG KAN', 'BURI RAM',
  'CHACHOENGSAO', 'CHAI NAT', 'CHAIYAPHUM', 'CHANTHABURI', 'CHIANG MAI',
  'CHIANG RAI', 'CHON BURI', 'CHUMPHON', 'KALASIN', 'KAMPHAENG PHET',
  'KANCHANABURI', 'KHON KAEN', 'KRABI', 'LAMPANG', 'LAMPHUN',
  'LOEI', 'LOP BURI', 'MAE HONG SON', 'MAHA SARAKHAM', 'MUKDAHAN',
  'NAKHON NAYOK', 'NAKHON PATHOM', 'NAKHON PHANOM', 'NAKHON RATCHASIMA',
  'NAKHON SAWAN', 'NAKHON SI THAMMARAT', 'NAN', 'NARATHIWAT', 'NONG BUA LAM PHU',
  'NONG KHAI', 'NONTHABURI', 'PATHUM THANI', 'PATTANI', 'PHANG NGA',
  'PHATTHALUNG', 'PHAYAO', 'PHETCHABUN', 'PHETCHABURI', 'PHICHIT',
  'PHITSANULOK', 'PHRA NAKHON SI AYUTTHAYA', 'PHRAE', 'PHUKET', 'PRACHIN BURI',
  'PRACHUAP KHIRI KHAN', 'RANONG', 'RATCHABURI', 'RAYONG', 'ROI ET',
  'SA KAEO', 'SAKON NAKHON', 'SAMUT PRAKAN', 'SAMUT SAKHON', 'SAMUT SONGKHRAM',
  'SARABURI', 'SATUN', 'SI SA KET', 'SING BURI', 'SONGKHLA',
  'SUKHOTHAI', 'SUPHAN BURI', 'SURAT THANI', 'SURIN', 'TAK',
  'TRANG', 'TRAT', 'UBON RATCHATHANI', 'UDON THANI', 'UTHAI THANI',
  'UTTARADIT', 'YALA', 'YASOTHON'
];

const THAILAND_PROVINCE_COMMON_SET = new Set(THAILAND_PROVINCES_COMMON.map(p => p.value));

export const THAILAND_PROVINCES = [
  ...THAILAND_PROVINCES_COMMON,
  ...THAILAND_PROVINCES_ALL
    .filter(p => !THAILAND_PROVINCE_COMMON_SET.has(p))
    .map(p => ({ value: p, labelCn: '' })), // 其余省份先用英文显示
];

// 旅行目的（前端中文展示，提交仍为英文 value）
export const TRAVEL_PURPOSES = [
  { value: 'HOLIDAY', labelCn: '旅游/度假' },
  { value: 'MEETING', labelCn: '会议' },
  { value: 'SPORTS', labelCn: '体育' },
  { value: 'BUSINESS', labelCn: '商务' },
  { value: 'INCENTIVE', labelCn: '奖励旅游' },
  { value: 'MEDICAL & WELLNESS', labelCn: '医疗与健康' },
  { value: 'EDUCATION', labelCn: '教育' },
  { value: 'CONVENTION', labelCn: '大会/会展' },
  { value: 'EMPLOYMENT', labelCn: '工作' },
  { value: 'EXHIBITION', labelCn: '展览' },
  { value: 'OTHERS (PLEASE SPECIFY)', labelCn: '其他（请注明）' },
];

// 住宿类型（前端中文展示，提交仍为英文 value）
export const ACCOMMODATION_TYPES = [
  { value: 'HOTEL', labelCn: '酒店' },
  { value: 'YOUTH HOSTEL', labelCn: '青年旅社' },
  { value: 'GUEST HOUSE', labelCn: '民宿/客栈' },
  { value: "FRIEND'S HOUSE", labelCn: '朋友家' },
  { value: 'APARTMENT', labelCn: '公寓' },
  { value: 'OTHERS (PLEASE SPECIFY)', labelCn: '其他（请注明）' },
];

// 交通方式（根据官网实测版本：AIR 下拉为 3 个选项；LAND/SEA 选项未在本次调研中抓全）
export const TRANSPORT_OPTIONS_BY_MODE = {
  AIR: ['COMMERCIAL FLIGHT', 'PRIVATE/CARGO AIRLINE', 'OTHERS (PLEASE SPECIFY)'],
  LAND: ['OTHERS (PLEASE SPECIFY)'],
  SEA: ['OTHERS (PLEASE SPECIFY)'],
};

// 性别选项
export const GENDER_OPTIONS = [
  { value: 'FEMALE', label: 'Female', labelCn: '女' },
  { value: 'MALE', label: 'Male', labelCn: '男' },
  { value: 'UNDEFINED', label: 'Undefined', labelCn: '未定义' },
];

// 交通方式
export const TRAVEL_MODES = [
  { value: 'AIR', label: 'Air', labelCn: '航空' },
  { value: 'LAND', label: 'Land', labelCn: '陆路' },
  { value: 'SEA', label: 'Sea', labelCn: '海路' },
];

// 常见职业（前端中文展示，提交仍为英文 value）
export const OCCUPATION_OPTIONS = [
  { value: 'STUDENT', labelCn: '学生' },
  { value: 'ENGINEER', labelCn: '工程师' },
  { value: 'SOFTWARE ENGINEER', labelCn: '程序员/软件工程师' },
  { value: 'TEACHER', labelCn: '教师' },
  { value: 'DOCTOR', labelCn: '医生' },
  { value: 'ACCOUNTANT', labelCn: '会计' },
  { value: 'SALES', labelCn: '销售' },
  { value: 'CIVIL SERVANT', labelCn: '公务员' },
  { value: 'FREELANCER', labelCn: '自由职业' },
  { value: 'RETIRED', labelCn: '退休' },

  // 更通用的大类（覆盖管理/研究等）
  { value: 'MANAGEMENT', labelCn: '管理/管理岗' },
  { value: 'ADMINISTRATION', labelCn: '行政/综合岗' },
  { value: 'HUMAN RESOURCES', labelCn: '人力资源' },
  { value: 'MARKETING', labelCn: '市场/市场营销' },
  { value: 'PRODUCT MANAGER', labelCn: '产品/产品经理' },
  { value: 'OPERATIONS', labelCn: '运营' },
  { value: 'RESEARCHER', labelCn: '研究/研究员' },
  { value: 'FINANCE', labelCn: '金融/投融资' },
  { value: 'LAWYER', labelCn: '法律/律师' },
  { value: 'DESIGNER', labelCn: '设计/设计师' },
];
